module.exports = __webpack_public_path__ + "static/media/JavaPaint.4260b23e.png";